module.exports = __webpack_public_path__ + "media/assets/images/blog/beta_features_introduction-small-8eb82ef46e8179f12ee9f217a60afd18.png";